import * as clsApi from "./classroomApi";
import { getScreenShareViewerUrl } from "../utils/getBackendUrl";

export interface InitScreenshareRequest {
	callId: string;
	teacherAlias: string;
	students: string[];
}

export interface ScreenshareTokenMap {
	[key: string]: string;
}

export interface InitScreenshareResponse {
	teacherToken: string;
	studentTokens: ScreenshareTokenMap;
	apiKey: string;
}

export interface GenerateScreenshareTokenRequest {
	callId: string;
	users: string[];
}

export interface GenerateScreenshareTokenResponse {
	tokens: ScreenshareTokenMap;
}

export async function initScreenshare(
	callId: string,
	teacherAlias: string,
	students: string[],
	applianceId: string
): Promise<InitScreenshareResponse> {
	const payload: InitScreenshareRequest = {
		callId: callId,
		teacherAlias: teacherAlias,
		students: students,
	};
	return await clsApi.Post2<InitScreenshareRequest, InitScreenshareResponse>(`v1/appliances/${applianceId}/screenshare/init`, payload);
}

export async function generateScreenshareToken(
	callId: string,
	users: string[],
	applianceId: string
): Promise<GenerateScreenshareTokenResponse> {
	const payload: GenerateScreenshareTokenRequest = {
		callId: callId,
		users: users,
	};
	return await clsApi.Post2<GenerateScreenshareTokenRequest, GenerateScreenshareTokenResponse>(
		`v1/appliances/${applianceId}/screenshare/tokens`,
		payload
	);
}

export function generateScreenshareCredentialString(apiKey: string, userId: string, token: string, callId: string): string {
	const credentials = {
		apiKey: apiKey,
		userId: userId,
		token: token,
		callId: callId,
	};
	return btoa(JSON.stringify(credentials));
}

export const generateViewerUrl = (key: string, token: string, userId: string, callId: string): string => {
	return `${getScreenShareViewerUrl(window.location.hostname)}/auth/${generateScreenshareCredentialString(key, userId, token, callId)}`;
};
